import settings from "../settings";

export default class AuthService {
  getBasicAuth() {
    return (
      "Basic " +
      new Buffer(settings.apiUsername + ":" + settings.apiPassword).toString(
        "base64"
      )
    );
  }

  setAdmin() {
    localStorage.setItem(settings.isAdmin, true);
  }

  isAdmin() {
    return localStorage.getItem(settings.isAdmin);
  }
}

export const authService = new AuthService();
